export const buttonEvents = {
  menu: 'buttonMenu',
  footer: 'buttonFooter',
  home: 'buttonHome',
  lancamentos: 'buttonLancamentos',
  marketingVendas: 'buttonMarketingVendas',
  gestaoFinanceiro: 'buttonGestaoFinanceiro',
  prontuario: 'buttonProntuario',
  agendaOnline: 'buttonAgendaOnline',
  precosEPlanos: 'buttonPrecosEPlanos',
  assinaturaEletronica: 'buttonAssinaturaEletronica',
  meuDoutor: 'buttonMeuDoutor',
  migracaoDados: 'buttonMigracao',
  redesEFranquias: 'buttonRedesEFranquias',
};

export const pageViewEvent = 'virtualPageView';

export const menuButtonNames = {
  testeGratis: 'testeGratisMenu',
};

export const footerButtonNames = {
  testarGratis: 'testarGratisFooter',
  testeGratisLink: 'testeGratisFooterLink',
};

export const homeButtonNames = {
  testarGratisHero: 'testarGratisHero',
  falarEspecialistaHero: 'falarEspecialistaHero',
  saibaMaisGestaoFinancas: 'saibaMaisGestaoFinancas',
  saibaMaisProntuarioDigital: 'saibaMaisProntuarioDigital',
  saibaMaisAgendaOnline: 'saibaMaisAgendaOnline',
  saibaMaisNovidades: 'saibaMaisNovidades',
  testarGratisDuvidas: 'testarGratisDuvidas',
};

export const precosEPlanosButtonNames = {
  testarGratisCardAgenda: 'testarGratisCardAgenda',
  testarGratisCardAgendaAnual: 'testarGratisCardAgendaAnual',
  testarGratisCardGestao: 'testarGratisCardGestao',
  testarGratisCardGestaoAnual: 'testarGratisCardGestaoAnual',
  testarGratisCardVendas: 'testarGratisCardVendas',
  testarGratisCardVendasAnual: 'testarGratisCardVendasAnual',
  testarGratisCardMarketing: 'testarGratisCardMarketing',
  compararPlanosActions: 'compararPlanosActions',
  testarGratisActions: 'testarGratisActions',
  falarEspecialistaFaleConosco: 'falarEspecialistaFaleConosco',
  saibaMaisRedes: 'saibaMaisRedes'
};

export const funcionalidadesButtonNames = {
  testarGratisHero: 'testarGratisHero',
  falarEspecialistaHero: 'falarEspecialistaHero',
  conhecaNossosPlanos: 'conhecaNossosPlanos',
  conhecaMaisAgendaOnline: 'conhecaMaisAgendaOnline',
  conhecaMaisProntuarioDigital: 'conhecaMaisProntuarioDigital',
  conhecaMaisGestaoFinancas: 'conhecaMaisGestaoFinancas',
  conhecaMaisMarketingVendas: 'conhecaMaisMarketingVendas',
  conhecaMaisAssinaturaEletronica: 'conhecaMaisAssinaturaEletronica',
};

export const migracaoDadosButtonNames = {
  testarGratisHero: 'testarGratisHero',
  falarEspecialistaHero: 'falarEspecialistaHero',
  falarEspecialistaMigracao: 'falarEspecialistaMigracao',
  testarGratisFaq: 'testarGratisFaq',
  falarEspecialistaFaq: 'falarEspecialistaFaq',
  testarGratisFeatures: 'testarGratisFeatures',
  testarGratisMigracao: 'testarGratisMigracao',
};

export const redesEFranquiasButtonNames = {
  redesEFranquiasHero: 'redesEFranquiasHero',
  redesEFranquiasComoFunciona: 'redesEFranquiasComoFunciona',
  redesEFranquiasBlocoFeatures: 'redesEFranquiasBlocoFeatures',
  redesEFranquias100SimplesDental: 'redesEFranquias100SimplesDental',
  redesEFranquiasDepoimento: 'redesEFranquiasDepoimento',
  redesEFranquiasBoxPreco: 'redesEFranquiasBoxPreco',
  redesEFranquiasFormFinal: 'redesEFranquiasFormFinal',
};
